import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultUserInfo } from '../interfaces/User'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C207DeviceUpdateProps {
  execDeviceUpdate: (deviceId: string, orderby: string) => Promise<ResultUserInfo>
  loading: loadStatus
}
// C207 デバイス更新API呼出
export const useC207DeviceUpdate = (): C207DeviceUpdateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execDeviceUpdate = async (deviceId: string, orderby: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // ボディ作成
      const body = { signage_orderby: orderby }
      // console.log(body);

      const response = await axios.put(
        buildDeviceUrl(deviceId, '/update'),
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execDeviceUpdate, loading }
}
